import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";

export default function IdleLogout({ timeout = 10 * 60 * 1000, children }) {
  const navigate = useNavigate();
  const location = useLocation();
  const timer = useRef(null);
  const locationRef = useRef(location);
  locationRef.current = location;

  const resetTimer = () => {
    if (timer.current) clearTimeout(timer.current);

    timer.current = setTimeout(() => {
      try {
        const userInfoRaw = localStorage.getItem("userInfo");
        const userInfo = userInfoRaw ? JSON.parse(userInfoRaw) : null;
        const path = locationRef.current?.pathname || "";
        const isPanel = path.startsWith("/dashboard/") && path !== "/dashboard/";
        if (userInfo?.username && isPanel) {
          localStorage.setItem(
            "lastSession",
            JSON.stringify({
              username: userInfo.username,
              route: path,
              logoutTime: Date.now(),
              logoutDate: new Date().toDateString(),
            })
          );
        } else {
          localStorage.removeItem("lastSession");
        }
      } catch (e) {
        // ignore — fall through to normal logout
      }

      // Clear login session
      localStorage.removeItem("user");
      sessionStorage.clear();

      navigate("/", { replace: true });
    }, timeout);
  };

  useEffect(() => {
    // Events that count as activity
    const events = ["mousemove", "mousedown", "keydown", "touchstart", "click"];

    events.forEach((event) => {
      window.addEventListener(event, resetTimer);
    });

    resetTimer();

    return () => {
      events.forEach((event) => {
        window.removeEventListener(event, resetTimer);
      });
      clearTimeout(timer.current);
    };
  }, []);

  return children;
}
